//@flow
import React, { Component } from "react";
import { View, Text, Dimensions, Image } from "react-native";
import { MySafeAreaView, Slider } from "../../components/common";
import { connect } from "react-redux";
import {
  changeProgress,
  submitFeelingRequest,
  changeFeeling,
} from "@microdoing/shared/services/feeling/actions";
import SignupHeader from "./SignupHeader";
import SignupBottom from "./SignupBottom";
import i18n from "@microdoing/shared/i18n";
import {
  widthPercentageToDP as wp,
  heightPercentageToDP as hp,
} from "react-native-responsive-screen";
import moment from "moment";
import * as Animatable from "react-native-animatable";
import { getUserId } from "@microdoing/shared/services/user/selectors";
import { getIsConnected } from "@microdoing/shared/services/network/selectors";
import theme from "app/Theme/Theme";

const ConfidenceImage = require("../../../assets/images/confidence.png");
const TeamImage = require("../../../assets/images/team.png");
const SpeakingImage = require("../../../assets/images/speaking.png");
const StressImage = require("../../../assets/images/stress.png");

const { width, height } = Dimensions.get("window");
const aspectRatio = height / width;
const isPad = () => aspectRatio < 1.6;

const components = [
  {
    value: "confidence",
    title: "feeling1-title",
    image: ConfidenceImage,
    leftLabel: "less well",
    rightLabel: "better",
  },
  {
    value: "stress",
    title: "feeling2-title",
    image: StressImage,
    leftLabel: "less well",
    rightLabel: "better",
  },
  {
    value: "publicSpeaking",
    title: "feeling3-title",
    image: SpeakingImage,
    leftLabel: "less well",
    rightLabel: "better",
  },
  {
    value: "teamCohesion",
    title: "feeling4-title",
    image: TeamImage,
    leftLabel: "less well",
    rightLabel: "better",
  },
];

class Feeling extends Component {
  state = {
    index: 0,
  };
  goNext = () => {
    this.setState({ index: this.state.index + 1 });
    this.props.changeProgress(this.props.progressRatio);
  };

  submit = () => {
    const {
      confidence,
      stress,
      publicSpeaking,
      teamCohesion,
      productivity,
      userId,
    } = this.props;
    this.props.submitFeelingRequest({
      userId,
      feeling: {
        date: moment(),
        confidence,
        stress,
        publicSpeaking,
        teamCohesion,
        productivity,
      },
    });
  };

  goBack = () => {
    this.setState({ index: this.state.index - 1 });
    this.props.changeProgress(-this.props.progressRatio);
  };

  onValueChange = value => {
    const feeling = components[this.state.index].value;
    this.props.changeFeeling({ [feeling]: value });
  };

  onPressExit = () => {
    this.props.navigation.navigate("Main");
  };

  renderItem = () => {
    return components.map((el, i) => {
      return (
        this.state.index === i && (
          <View key={i} style={styles.mainViewStyle}>
            <Animatable.View
              useNativeDriver
              animation="fadeInLeft"
              style={[styles.middleViewStyle, { marginBottom: 50 }]}
            >
              <Text style={styles.mainTextStyle}>
                {i18n.t("how would you")}
                <Text style={{ fontWeight: "bold" }}> {i18n.t(el.title)} </Text>
                {i18n.t("has evolve this week")}
              </Text>
              <Image
                source={el.image}
                style={styles.image}
                resizeMode="contain"
              />
            </Animatable.View>
            <View style={styles.bottomViewStyle}>
              <View style={styles.sliderPosition}>
                <Slider
                  value={this.props[el.value]}
                  onValueChange={this.onValueChange}
                  leftLabel={i18n.t(el.leftLabel)}
                  rightLabel={i18n.t(el.rightLabel)}
                  minimumValue={-5}
                  maximumValue={5}
                  hasCustomValue
                />
              </View>
              <SignupBottom
                rightButtonText={
                  i === components.length - 1 ? "submit" : "signup-next-button"
                }
                noLeftButton={i === 0}
                onPressBack={this.goBack}
                onPressNext={
                  i === components.length - 1 ? this.submit : this.goNext
                }
              />
            </View>
          </View>
        )
      );
    });
  };

  render() {
    return (
      <MySafeAreaView
        style={styles.mainViewStyle}
        testID="feeling-evolution-screen"
      >
        <View style={styles.topViewStyle}>
          <SignupHeader
            onPressExit={this.onPressExit}
            title="feeling-title"
            progress={this.props.progress}
            scrollEnabled={false}
          />
        </View>
        {this.renderItem(this.state.index)}
      </MySafeAreaView>
    );
  }
}

const styles = {
  mainViewStyle: {
    flex: 1,
    backgroundColor: "white",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  },
  topViewStyle: {
    justifyContent: "flex-start",
    alignItems: "center",
    flexDirection: "column",
  },
  middleViewStyle: {
    flex: 3,
    top: 20,
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  },
  bottomViewStyle: {
    bottom: isPad() ? 10 : height < 600 ? 5 : 15,
    flex: 1,
    justifyContent: "flex-end",
    alignItems: "center",
  },
  sliderPosition: {
    marginBottom: height < 600 ? 15 : 40,
  },
  mainTextStyle: {
    textAlign: "center",
    marginBottom: 20,
    width: wp("75%"),
    fontSize: wp("6%"),
    fontWeight: "normal",
    color: theme.colors["neutral.900"],
  },
  subTextStyle: {
    top: 10,
    height: 17,
    fontSize: 14,
    textAlign: "center",
    color: "rgba(155, 155, 155, 0.6)",
  },
  subTextGoldStyle: {
    width: 326,
    height: 17,
    fontSize: 14,
    textAlign: "center",
    color: "#FFCB34",
    fontWeight: "bold",
  },
  errorText: {
    fontSize: 14,
    color: "red",
  },
  forgottenPassStyle: {
    marginTop: 13,
  },
  register: {
    marginTop: 13,
    marginBottom: 5,
  },
  image: {
    height: (height * 1) / 3,
  },
};

const mapStateToProps = state => {
  const {
    progress,
    progressRatio,
    confidence,
    stress,
    teamCohesion,
    publicSpeaking,
    productivity,
    requesting,
  } = state.feeling;

  return {
    isConnected: getIsConnected(state),
    userId: getUserId(state),
    requesting,
    productivity,
    confidence,
    teamCohesion,
    publicSpeaking,
    stress,
    progress,
    progressRatio,
  };
};

export default connect(mapStateToProps, {
  submitFeelingRequest,
  changeProgress,
  changeFeeling,
})(Feeling);
